module.exports = __webpack_public_path__ + "static/media/207-mali.06959147.svg";